export default {"src":"/_next/static/media/ic-profile.f149728c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};